import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getMotivosAusencia() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("motivosAusencia/access/listar").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getMotivosAusenciaTipo(context, tipo) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("motivosAusencia/access/listarTipo", {TIPO: tipo}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getMotivosAusencias(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
                dados.pagina = 1;
                dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("motivosAusencia/access/listarMotivo", dados).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    getMotivoAusencia(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("motivosAusencia/access/obter", {ID_MOTIVO_AUSENCIA: dados.id, componente: dados.componente}).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    deleteMotivoAusencia(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("motivosAusencia/access/excluir", {ID_MOTIVO_AUSENCIA: dados.id, componente: dados.componente}).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    postMotivoAusencia(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("motivosAusencia/access/salvar", dados).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};